import React from "react";
import PropTypes from "prop-types";
import { Grid, Typography, Button, Divider, Checkbox } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import { compose, withHandlers } from "recompose";
import InputWithTitle from "../../../../../components/InputWithTitle/InputWithTitle";
import {
  WEBHOOK_DETAILS,
  PROVIDE_US_WITH_YOUR_URL,
  ENTER_URL_HERE,
  GENERATE_NEW_SECRET,
  REVOKE,
} from "../../../../../constants/strings";
import { showRevokeSharedSecretModal } from "../../../../../features/modal/modal.actions";
import styles from "../Webhooks.module.scss";
import { formatDate } from "../../../../../utils/timeFormater";
import { capitalize } from "lodash";

const useCheckboxStyles = makeStyles((theme) => ({
  checkbox: {
    margin: 0,
    "&.Mui-checked": {
      color: theme.palette.primary.main,
    },
  },
}));

const WebhookDetails = ({
  webhookIsEnabled,
  webhookUrl,
  webhookSecrets,
  webhookType,
  onGenerateSecret,
  onSecretInUseToggle,
  handleRevokeSecret,
  handleUrlChange,
}) => {
  const checkboxClasses = useCheckboxStyles();
  const inUseCount = (webhookSecrets || []).filter((s) => s.inUse).length;
  return (
    <>
      {webhookIsEnabled && (
        <>
          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h6">{`${capitalize(
              webhookType
            )} ${WEBHOOK_DETAILS}`}</Typography>
            <Typography variant="body1" gutterBottom>
              {PROVIDE_US_WITH_YOUR_URL}
            </Typography>
          </Grid>

          <Grid item xs={12} md={8}>
            <InputWithTitle
              placeholder={ENTER_URL_HERE}
              input={{
                value: webhookUrl || "",
                onChange: handleUrlChange,
                onBlur: () => {},
              }}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <Button
              variant="contained"
              color="primary"
              className={
                webhookSecrets?.length >= 2 ? styles.disabledButton : ""
              }
              disabled={webhookSecrets?.length >= 2}
              onClick={() => onGenerateSecret(webhookType)}
              style={{
                width: "100%",
                height: "51px",
              }}
            >
              {GENERATE_NEW_SECRET}
            </Button>
          </Grid>

          {webhookSecrets?.length > 0 && (
            <>
              {webhookSecrets?.map((secret, index) => (
                <Grid item xs={12} key={secret?.secretId || index}>
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} md={1}>
                      <Checkbox
                        checked={secret?.inUse || false}
                        disabled={!!secret?.inUse && inUseCount === 1}
                        className={checkboxClasses.checkbox}
                        onChange={(event) =>
                          onSecretInUseToggle(
                            secret?.secretId,
                            event.target.checked
                          )
                        }
                      />
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <Typography variant="body2" color="textSecondary">
                        {formatDate(secret?.createdAt, "dd/MM/yyyy")}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={7}>
                      <InputWithTitle
                        input={{
                          value: secret?.sharedSecret || "",
                          onChange: () => {},
                          onBlur: () => {},
                        }}
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} md={2}>
                      {webhookSecrets?.length > 1 && (
                        <Button
                          fullWidth
                          onClick={() => handleRevokeSecret(secret)}
                          disabled={secret?.inUse}
                          className={secret.inUse ? styles.disabledButton : ""}
                        >
                          {REVOKE}
                        </Button>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              ))}
            </>
          )}
        </>
      )}
    </>
  );
};

WebhookDetails.propTypes = {
  webhookIsEnabled: PropTypes.bool.isRequired,
  webhookUrl: PropTypes.string,
  webhookSecrets: PropTypes.arrayOf(
    PropTypes.shape({
      secretId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      inUse: PropTypes.bool,
      createdAt: PropTypes.string,
      sharedSecret: PropTypes.string,
    })
  ),
  webhookType: PropTypes.string,
  onGenerateSecret: PropTypes.func,
  onSecretInUseToggle: PropTypes.func,
  handleRevokeSecret: PropTypes.func,
  handleUrlChange: PropTypes.func,
};

const mapDispatchToProps = (dispatch) => ({
  dispatch,
});

export default compose(
  connect(null, mapDispatchToProps),
  withHandlers({
    handleRevokeSecret:
      ({ dispatch, onRevokeSecret, webhookType }) =>
      (secret) => {
        dispatch(
          showRevokeSharedSecretModal({
            secretValue: secret.sharedSecret,
            onConfirmClick: () => {
              if (onRevokeSecret) {
                onRevokeSecret(secret.secretId, webhookType);
              }
            },
          })
        );
      },
    handleUrlChange:
      ({ onWebhookUrlChange }) =>
      (event) => {
        onWebhookUrlChange(event.target.value);
      },
  })
)(WebhookDetails);
